import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PublicPage, SubTitle } from "../components/PublicPage";
import { Button } from "../components/ui/button";
import { useLang } from "../i18n";

const TEXT = {
  it: {
    title: "Chi siamo",
    p: [
      "RISE your LIFE è un programma di benessere e longevità per il welfare aziendale. È un servizio di MDS – MED SRL.",
      "Aiutiamo le persone a capire come vivono e a trasformare una settimana di abitudini in un piano semplice e attuabile. Le aree che osserviamo sono sei: alimentazione, esercizio fisico, sonno, freddo, respirazione e relazioni.",
      "Il piano è guidato da professionisti del settore e supportato dall'intelligenza artificiale.",
    ],
    sub: "I nostri impegni",
    list: [
      "È un servizio di coaching di benessere, senza finalità diagnostiche o terapeutiche.",
      "La tua azienda non riceve i tuoi dati personali.",
      "Puoi chiedere la cancellazione dei tuoi dati in qualsiasi momento.",
    ],
    pre: "Per i dettagli leggi l'", link: "Informativa sulla Privacy", post: ".", cta: "Inizia ora",
  },
  en: {
    title: "About us",
    p: [
      "RISE your LIFE is a wellbeing and longevity programme for corporate welfare. It is a service of MDS – MED SRL.",
      "We help people understand how they live and turn a week of habits into a simple, actionable plan. We look at six areas: nutrition, physical activity, sleep, cold, breathing and relationships.",
      "The plan is guided by industry professionals and supported by artificial intelligence.",
    ],
    sub: "Our commitments",
    list: [
      "It is a wellbeing coaching service, with no diagnostic or therapeutic purpose.",
      "Your employer does not receive your personal data.",
      "You can ask for your data to be deleted at any time.",
    ],
    pre: "For details read the ", link: "Privacy Policy", post: ".", cta: "Get started",
  },
};

export default function About() {
  const { lang } = useLang();
  const c = TEXT[lang] || TEXT.it;
  return (
    <PublicPage title={c.title}>
      <section className="space-y-3">{c.p.map((x, i) => <p key={i}>{x}</p>)}</section>
      <section>
        <SubTitle>{c.sub}</SubTitle>
        <ul className="list-disc pl-5 space-y-1.5">{c.list.map((x, i) => <li key={i}>{x}</li>)}</ul>
      </section>
      <p>{c.pre}<Link to="/privacy" className="text-[#B5651D] hover:underline" data-testid="about-privacy-link">{c.link}</Link>{c.post}</p>
      <Link to="/register" className="inline-block">
        <Button data-testid="about-start-btn" className="rounded-full bg-[#3F6E85] hover:bg-[#2B4A59] text-white px-8 h-12 text-base gap-2 hover:-translate-y-0.5 transition-transform">
          {c.cta} <ArrowRight className="w-4 h-4" />
        </Button>
      </Link>
    </PublicPage>
  );
}
